(() => {
  const searchPath = new URL(document.currentScript.dataset.searchUrl, location.origin).pathname;
  const modelNames = ["fiji","apui","joy","yumi","nicaragua","zara","leonie","caipirinha","perizoma","caracas","vita alta","kyla","amanda","nami","lorena","stella","maryna","midori","marta","pam","taylor","nicole","gilda","key","regolare","ica","hamina","malibu","triangolino","sailor","elly","fru fru","ary","basic","helena","matilde","ibiza","trikini","meg","ring","kai","manhattan","victory","raffi","elodie","dixie","hanna","jo","hibiscus","xena","mykonos","emma","aisha","betty","yaki","meredith","michelle","lea","naomi","sunset","maracay","ryo","velo","tami","amalfi coast","jenny b","savan","polly","bandy","mini wrapper","nodino","brasiliano","bra","hawai","celine","scrunchies","gonna","kimono","manicotti","cintura","coppa","gift card"];
  const exactModelQuery = (query) => {
    if (/["():*\\]|(?:^|\s)(?:AND|OR|NOT)(?:\s|$)/.test(query)) return query;
    if (/(?:^|\s)-/.test(query)) return query;
    const normalized = ' ' + query.trim().toLowerCase().replace(/\s+/g, ' ') + ' ';
    if (!modelNames.some((name) => normalized.includes(' ' + name + ' '))) return query;
    return query.trim().split(/\s+/).map((word) => 'title:"' + word + '"').join(' ');
  };
  const currentUrl = new URL(location.href);
  if (currentUrl.pathname === searchPath) {
    const query = currentUrl.searchParams.get('q') || '';
    const exactQuery = exactModelQuery(query);
    if (query !== exactQuery) {
      currentUrl.searchParams.set('q', exactQuery);
      currentUrl.searchParams.delete('page');
      location.replace(currentUrl.href);
      return;
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('form[action]').forEach((form) => {
      if (new URL(form.action, location.origin).pathname !== searchPath) return;
      form.addEventListener('formdata', (event) => {
        const query = event.formData.get('q');
        if (typeof query === 'string') event.formData.set('q', exactModelQuery(query));
      });
    });
  }, { once: true });
})();